import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useInsurancesBehaviours} from "../api/insuranceandbehaviourapi";
import {Button} from "react-bootstrap";
import {Section} from "../components/grouping/Section";
import {minioBaseUrl} from "../data/defaultConfig";

export function Insurance(props) {
    const {insurancesBehaviours} = useInsurancesBehaviours();
    console.log(insurancesBehaviours)
    return <BasePageLayout title={'Verzekeringen'}>
        {insurancesBehaviours?.filter(i =>
            i.type === 'insurance')?.map(i => <InsuranceLink key={i.id} insurance={i}/>)}
    </BasePageLayout>
}

function InsuranceLink(props) {
    const {insurance} = props;

    console.log(insurance.fileCategories)
    return <div className={'ms-5 mt-3'}>
        <h5>{insurance.title}</h5>
        <Button className={'btn-light '} href={`${minioBaseUrl}${insurance?.fileinsurancebehavious?.url}`}
                target={'_blank'}>Download {insurance.title}</Button>
    </div>
}